import Vue from 'vue';
import index from './index.vue';
import cmnRegister from '@ibkr/clientportal.common/src/store/register'

window.PORTAL_BASE_URL = process.env.PORTAL_BASE_URL;

const store = new Vuex.Store({});

cmnRegister(store);

const app = new Vue({ store, ...index });

if (window.AUTO_MOUNT !== false) {
    const appEl = document.getElementById('app');
    if (appEl) {
        app.$mount('#app');
    }
}

window.sbiApp = app;